import React from 'react';
import { motion } from 'framer-motion';
import { Wallet, Home, TrendingUp, Clock, Rocket } from 'lucide-react';
const benefits = [{
  icon: Wallet,
  title: 'Baja inversión inicial',
  description: 'Empezá con los utensilios que ya tenés en tu cocina.',
  image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&q=80&w=400'
}, {
  icon: Home,
  title: 'Trabajo desde casa',
  description: 'Sin alquileres ni traslados. Tu hogar es tu centro de producción.',
  image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&q=80&w=400'
}, {
  icon: TrendingUp,
  title: 'Alta demanda constante',
  description: 'La comida casera y los eventos siempre tienen público dispuesto a comprar.',
  image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=400'
}, {
  icon: Clock,
  title: 'A tu ritmo',
  description: 'Manejá tus propios horarios y decidí cuánto querés trabajar.',
  image: 'https://images.unsplash.com/photo-1495364141860-b0d03eccd065?auto=format&fit=crop&q=80&w=400'
}, {
  icon: Rocket,
  title: 'Escalable',
  description: 'Empezá pequeño y crecé hasta tener tu propio equipo de trabajo.',
  image: 'https://images.unsplash.com/photo-1533750349088-cd871a92f312?auto=format&fit=crop&q=80&w=400'
}];
export function Benefits() {
  return <section className="py-24 bg-[#F5F0EB]" data-id="element-8">
      <div className="container mx-auto px-6 md:px-12" data-id="element-9">
        <div className="text-center mb-16" data-id="element-10">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-stone-800 mb-4" data-id="element-11">
            ¿Por qué este modelo funciona?
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '60px'
        }} viewport={{
          once: true
        }} className="h-1 bg-[#C9A96E] mx-auto rounded-full" data-id="element-12" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-13">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-white/60 backdrop-blur-sm rounded-2xl border border-white/40 hover:bg-white transition-colors duration-300 overflow-hidden" data-id="element-14">
                <div className="h-36 overflow-hidden" data-id="element-15">
                  <img src={benefit.image} alt={benefit.title} className="w-full h-full object-cover" data-id="element-16" />
                </div>
                <div className="p-8" data-id="element-17">
                  <div className="w-14 h-14 bg-[#C9A96E]/10 rounded-xl flex items-center justify-center mb-6 text-[#C9A96E]" data-id="element-18">
                    <Icon size={28} strokeWidth={1.5} data-id="element-19" />
                  </div>
                  <h3 className="text-xl font-serif font-bold text-stone-800 mb-3" data-id="element-20">
                    {benefit.title}
                  </h3>
                  <p className="text-stone-600 leading-relaxed" data-id="element-21">
                    {benefit.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}